import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { Input } from '../default/input';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

type CustomInputProps = InputProps & {
  icon?: React.ReactNode;
};

export const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(({ icon, ...props }, ref) => {
  return (
    <div className="relative w-full">
      {icon && <div className="absolute left-2 top-1/2 -translate-y-1/2">{icon}</div>}
      <Input
        {...props}
        ref={ref}
        id={props.id}
        className={cn(
          'border-shade-medium-default rounded-1 h-8 w-full px-2 py-1 text-sm md:text-sm',
          icon && 'pl-7',
          props.className,
        )}
      />
    </div>
  );
});

export const InputWithUnitLabel = forwardRef<HTMLInputElement, InputProps & { unit: string }>(
  ({ unit, disabled, ...props }, ref) => {
    return (
      <div className={cn('relative flex h-10 items-center', disabled && 'pointer-events-none')}>
        <Input
          {...props}
          disabled={disabled}
          ref={ref}
          id={props.id}
          className={cn('border-shade-light-default rounded-l-1 h-full flex-1 pr-[calc(46px+12px)]', props.className)}
        />
        <div className="absolute inset-y-0 right-0">
          <label
            id={props.id}
            htmlFor={props.id}
            className={cn(
              'rounded-r-1 bg-shade-white-active border-r-1 border-shade-light-default flex h-full max-h-[40px] shrink-0 items-center justify-center rounded-l-none border border-l-0 px-4 py-2 font-normal',
              disabled && 'opacity-50',
            )}
          >
            <p className={cn('text-shade-medium-default whitespace-nowrap text-base', disabled && 'opacity-50')}>
              {unit}
            </p>
          </label>
        </div>
      </div>
    );
  },
);

InputWithUnitLabel.displayName = 'InputWithUnitLabel';
